<template>
  <el-container>
    <!-- 标题 -->
    <el-header class="pa-0">
      <div class="dy-flex px-30 pt-10 bg-color-w">
        <div>
          <div class="fs-22">
            <img
              src="/img/images/dbsx_icon.png"
              style="width: 40px"
              class="vertical-a-m"
            />
            <span class="pl-5">应用中心</span>
          </div>
        </div>
        <div class="wt-p-80">
          <el-input
            v-model="xtmc"
            placeholder="全局应用搜索"
            class="wt-p-40 ml-p-30"
            clearable
            @focus="xmmcfocus"
            @blur="xmmcblur"
            @input="xmmcChange"
          >
            <template #append>
              <el-button type="primary">搜索</el-button>
            </template>
          </el-input>
        </div>
        <!-- <div>
          <el-button>问题反馈</el-button>
        </div> -->
      </div>
    </el-header>
    <!-- 内容 -->
    <el-main>
      <!-- 筛选部分 -->
      <el-row v-if="isSearch" class="pl-50 pr-50">
        <!-- 应用分类 -->
        <div class="dy-flex ma-auto wt-p-80 bg-color-w">
          <div class="bg-color-1blue px-10 py-15">应用分类</div>
          <div class="px-10 py-15">
            <span
              :style="activeSys === 'all' ? activeSpanStyle : null"
              class="fs-16 ml-5 ff-A cursor-p"
              @click="setActiveSys('all')"
              >全部</span
            >
          </div>
          <template v-for="(item, index) in myMenu">
            <div :key="index" class="px-10 py-15">
              <span
                :style="activeSys === item.sysid ? activeSpanStyle : null"
                class="fs-16 ml-5 ff-A cursor-p"
                @click="setActiveSys(item.sysid)"
              >
                {{ item.sysname }}
              </span>
            </div>
          </template>
        </div>
        <!-- 应用 -->
        <template v-for="i in searchData">
          <el-row
            :key="i.qid"
            class="bg-color-w ma-auto my-20 wt-p-80 px-20 py-15"
          >
            <!-- 图标 -->
            <el-col :span="20" class="dy-flex">
              <img
                :src="'/img/images/link/' + i.img"
                class="search-navi-icon cursor-p mt-10"
                @onerror="naviRequireImg"
              />
              <!-- 描述 -->
              <div class="pl-10">
                <p class="cursor-p">
                  {{ i.qname }}
                </p>
                <p class="fs-14 color-6g pt-5">
                  {{ i.memo3 }}
                </p>
                <!-- <p class="fs-14 color-6g">
                  版本：V1.1.1 |更新时间：2021/01/12
                </p> -->
                <p class="pt-5">
                  <el-tag size="mini" effect="plain" class="mr-5 br-10">{{
                    i.sysname
                  }}</el-tag>
                </p>
              </div>
            </el-col>
            <el-col :span="4">
              <div>
                <el-button
                  type="primary"
                  size="small"
                  class="mt-10"
                  @click="getSysUrl(i)"
                  >进入应用</el-button
                >
              </div>
              <div>
                <el-button
                  size="small"
                  class="mt-10"
                  @click="isCommon(i.iscy, i)"
                >
                  {{
                    i.iscy === "2"
                      ? $t('common.cxcy')
                      : i.iscy === "1"
                      ? $t('common.gdgn')
                      : $t('common.swcy')
                  }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-row>
      <!-- 应用部分 -->
      <div v-else class="dy-flex jy-content-c">
        <!-- 左侧导航 -->
        <div class="navig" :style="navigStyle">
          <div class="">
            <div class="bg-color-w text-a-c bg-color-primary color-w py-15">
              应用分类
            </div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-vertical-demo br-color-1g overf-y-a"
              :style="menuHtStyle"
              unique-opened
            >
              <template v-for="(it, index) in myMenu">
                <el-submenu
                  :index="index.toString()"
                  :key="it.sysid"
                  v-if="it.sysMenuList.length > 0"
                >
                  <template #title>
                    <span @click="jump(it.sysname)">{{ it.sysname }}</span>
                  </template>
                  <template v-for="(i, inde) in it.sysMenuList">
                    <el-menu-item
                      :index="index.toString() + inde"
                      :key="i.qid"
                      class="ht-40 pl-10"
                      @click="jump(i.qname)"
                      >{{ i.qname }}</el-menu-item
                    >
                  </template>
                </el-submenu>
                <el-menu-item
                  :index="index.toString()"
                  :key="index"
                  class="ht-40"
                  @click="jump(it.sysname)"
                  v-else
                >
                  <span>{{ it.sysname }}</span>
                </el-menu-item>
              </template>
            </el-menu>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div :style="contentStyle">
          <!-- 头部图片 -->
          <div></div>
          <!-- 常用应用 -->
          <div class="bg-color-w pl-20 py-20 pr-10">
            <div class="pb-10">
              <span class="fs-16">常用应用</span>
              <span class="pl-10 color-6g fs-14"
                >点击应用右上角星星图形，即可加入常用应用</span
              >
            </div>
            <div class="dy-flex menuList">
              <template v-for="(item, index) in cyNavigationData">
                <!-- 应用 -->
                <div
                  :key="index"
                  class="nav-row-item mt-10 mr-16"
                  :style="navItemStyle"
                >
                  <div class="bg-color-1g dy-flex pl-15 pr-5 py-10 yynavi">
                    <!-- 图标 -->
                    <div class="vertical-a-m dy-flex">
                      <img
                        :src="'/img/images/link/' + item.img"
                        @click="getSysUrl(item)"
                        class="navi-icon cursor-p vertical-a-m"
                        @onerror="naviRequireImg"
                      />
                      <!-- 描述 -->
                      <div class="pl-10">
                        <p @click="getSysUrl(item)" class="fs-14 cursor-p">
                          {{ item.qname }}
                        </p>
                        <p class="fs-14 color-6g">{{ item.memo3 }}</p>
                      </div>
                    </div>
                    <!-- 星星 -->
                    <div class="wt-20">
                      <img
                        :src="
                          cyNavigationData[index].iscy === '1' ||
                          cyNavigationData[index].iscy === '2'
                            ? common2
                            : common1
                        "
                        class="start"
                        @click="isCommon(item.iscy, item)"
                        :title="
                          item.iscy === '2'
                            ? $t('common.cxcy')
                            : item.iscy === '1'
                            ? $t('common.gdgn')
                            : $t('common.swcy')
                        "
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!-- 全部应用 -->
          <div @scroll="onScroll" class="">
            <template v-for="(item, index) in myMenu">
              <div :key="index" class="bg-color-w pl-20 py-20 pr-10 mt-20">
                <div>
                  <span class="scroll-item">{{ item.sysname }}</span>
                  <span class="pl-10 color-6g fs-14">{{ item.xtjj }}</span>
                </div>
                <template v-for="(it, inde) in item.sysMenuList">
                  <p
                    :key="it.qname"
                    class="fs-14 scroll-item mt-20 pl-10 br-color-b bw-l-2 br-l-solid"
                  >
                    {{ it.qname }}
                  </p>
                  <div :key="inde" class="menuList">
                    <template v-for="(i, ind) in it.sysMenuList">
                      <!-- 应用 -->
                      <div
                        :key="ind"
                        class="nav-row-item pt-10 mr-16"
                        :style="navItemStyle"
                      >
                        <div
                          class="bg-color-1g dy-flex pl-15 pr-5 py-10 yynavi"
                        >
                          <!-- 图标 -->
                          <div
                            class=" dy-flex cursor-p"
                            @click="toSysUrl(i, it.sysMenuList, ind, index)"
                          >
                            <img
                              :src="'/img/images/link/' + i.img"
                              @click="toSysUrl(i, it.sysMenuList, ind, index)"
                              class="navi-icon"
                              @onerror="naviRequireImg"
                            />
                            <!-- 描述 -->
                            <div class="pl-10">
                              <p
                                @click="toSysUrl(i, it.sysMenuList, ind, index)"
                                class="fs-14"
                              >
                                {{ i.qname }}
                              </p>
                              <p class="fs-14 color-6g">{{ i.memo3 }}</p>
                            </div>
                          </div>

                          <!-- 星星 -->
                          <div class="wt-20">
                            <img
                              :src="
                                i.iscy === '1' || i.iscy === '2'
                                  ? common2
                                  : common1
                              "
                              class="start"
                              @click="isCommon(i.iscy, i)"
                              :title="
                                i.iscy === '2'
                                  ? $t('common.cxcy')
                                  : i.iscy === '1'
                                  ? $t('common.gdgn')
                                  : $t('common.swcy')
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";
export default {
  // 应用中心
  name: "appCenter",
  computed: {
    activeSpanStyle() {
      return {
        color: "#0C6CE5",
        "font-weight": "600",
      };
    },
    menuHtStyle() {
      return {
        height: this.$store.state.screenHeight - 200 + "px",
      };
    },
    navigStyle() {
      let left = "";
      let w = this.$store.state.screenWidth;
      if (w >= 1464) {
        left = (w - 1110) / 2 + "px";
      } else {
        left = "330px";
      }
      return {
        left: left,
      };
    },
    contentStyle() {
      let width = "";
      let w = this.$store.state.screenWidth;
      if (w >= 1464) {
        width = "1000px";
      } else {
        if (w > 768) {
          width = w - 304 + "px";
        } else {
          width = "464px";
        }
      }
      return {
        width: width,
        "margin-left": "200px",
      };
    },
    navItemStyle() {
      let width = "";
      let w = this.$store.state.screenWidth;
      if (w >= 1464) {
        width = "226px";
      } else {
        width = "200px";
      }
      return {
        width: width,
      };
    },
  },
  data() {
    return {
      common2: "/img/images/star2.png",  // 已设置常用使用
      common1: "/img/images/star1.png",  // 未设置常用使用
      xtmc: "",                          // 筛选系统名称
      activeIndex: "0",
      activeSys: "all",
      cyNavigationData: [],
      menuData: [],
      uniqueNum: "Y118101-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      isSearch: false,
      searchData: [],
      screenWidth: "",
      screenHeight: "",
      myMenu: [],
    };
  },
  methods: {
    // 获取应用导航
    getMyMenu() {
      yhxx.getMyMenu().then((res) => {
        this.$store.commit("yhxx/setMyMenu", res.data.data);
        this.$store.commit(
          "navigation/setCyNavigationData",
          res.data.data[0].sysMenuList
        );
        this.menuData = JSON.parse(JSON.stringify(res.data.data));
        this.cyNavigationData = res.data.data[0].sysMenuList;
        this.menuData.shift();
        this.myMenu = this.menuData;
        this.setSearchData();
      });
    },
    // 判断是否为常用
    isCommon(iscy, item) {
      let param = {
        yhbh: item.rydm,
        qid: item.qid,
        sysid: item.sysid,
      };
      if (iscy === "2") {
        yhxx.delMyCyMenu(param).then((res) => {
          this.getMyMenu();
        });
      } else if (iscy === "1") {
        this.$message.error(this.$t('common.gdgnwfyc'));
      } else {
        yhxx.addMyCyMenu(param).then((res) => {
          this.getMyMenu();
        });
      }
    },
    // 系统图标加载失败时回调方法
    naviRequireImg(event) {
      var img = event.target;
      img.src = "error.png";
      img.onerror = null;
    },
    // 锚点滚动
    jump(value) {
      var items = document.querySelectorAll(".scroll-item");
      items.forEach((item, i) => {
        if (item.innerHTML.replace(/(^\s*)|(\s*$)/g, "") === value) {
          items[i].scrollIntoView({
            block: "start", //默认跳转到顶部
            behavior: "smooth", //滚动的速度
          });
        }
      });
    },
    // 设置锚点
    onScroll(e) {
      let scrollItems = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop;
        if (judge) {
          this.activeStep = i;
          break;
        }
      }
    },
    // 其他系统或功能跳转
    toSysUrl(item, items, ind, index) {
      this.$store.commit("setAppMenuIndex", index + 1);
      let url = null;
      if (item.urlflg == "0") {
        this.$router.push({
          name: "/qtxt",
          params: {
            url: url,
            title: item.qname,
            menus: items,
            activeindex: ind,
          },
        });
      } else {
        // yhxx.getNewPageUrl(item).then((res) => {
        //   url = res.data.data;
        //   this.$store.commit("setIframeUrl", url);
        if (item.urlflg == "1") {
          if (item.linktype == "0") {
            yhxx.getNewPageUrl(item).then((res) => {
              url = res.data.data;
              var newwindow = window.open(url);
            });
            // setTimeout(() => {
            //   newwindow.postMessage("测试信息5", url);
            // }, 1000);
          } else {
            // 跳转嵌套页面
            this.$router.push({
              name: "/qtxt",
              params: {
                url: url,
                title: item.qname,
                menus: items,
                activeindex: ind,
              },
            });
          }
        } else if (item.urlflg == "2") {
          yhxx.getNewPageUrl(item).then((res) => {
            url = res.data.data;
            var newwindow = window.open(url);
          });
        }
        // });
      }
    },
    // 获取常用或筛选父级菜单
    getSysUrl(sys) {
      this.display = 0;
      let s = [];
      let num = 0;
      let sysxh = 0;
      this.menuData.forEach((item, index) => {
        if (index > 0) {
          if (item.sysMenuList.length > 0) {
            item.sysMenuList.forEach((it) => {
              if (it.sysMenuList.length > 0) {
                it.sysMenuList.forEach((i, ix) => {
                  if (i.qid === sys.qid) {
                    s = it.sysMenuList;
                    num = ix;
                    sysxh = index;
                  }
                });
              }
            });
          }
        }
      });
      this.toSysUrl(sys, s, num, sysxh);
    },
    // 筛选系统
    xmmcChange(value) {
      this.xmFilter = [];
      if (value !== "" && value !== null) {
        this.isSearch = true;
        this.setSearchData();
      } else {
        this.isSearch = false;
      }
    },
    // 筛选框获得焦点
    xmmcfocus() {
      this.setSearchData();
      if (this.xtmc !== "" && this.xtmc !== null) {
        this.isSearch = true;
        this.xmmcChange(this.xmmc);
      }
    },
    // 筛选框失去焦点
    xmmcblur() {
      setTimeout(() => {
        if (this.xtmc == "" || this.xtmc == null) {
          this.isSearch = false;
        }
      }, 250); //延迟100毫秒
    },
    // 筛选系统
    setActiveSys(sysid) {
      this.activeSys = sysid;
      this.setSearchData();
    },
    setSearchData() {
      this.searchData = [];
      this.menuData.forEach((item) => {
        if (this.activeSys !== "all" && item.sysid == this.activeSys) {
          item.sysMenuList.forEach((it) => {
            it.sysMenuList.forEach((i) => {
              if (
                this.xtmc !== null &&
                this.xtmc !== "" &&
                i.qname.indexOf(this.xtmc) !== -1
              ) {
                this.searchData.push(i);
              }
            });
          });
        }
        if (this.activeSys == "all") {
          item.sysMenuList.forEach((it) => {
            it.sysMenuList.forEach((i) => {
              if (
                this.xtmc !== null &&
                this.xtmc !== "" &&
                i.qname.indexOf(this.xtmc) !== -1
              ) {
                this.searchData.push(i);
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getMyMenu();
    // 监听浏览器的宽和高
    this.$store.commit("setScreenWidth", document.body.clientWidth);
    this.$store.commit("setScreenHeight", document.body.clientHeight);
    // window.onresize = () => {
    //   return (() => {
    //     document.body.style.fontSize = this.$store.state.sysCs.fontSize + "px";
    //     this.$store.commit("setScreenWidth", document.body.clientWidth);
    //     this.$store.commit("setScreenHeight", document.body.clientHeight);
    //   })();
    // };
  },
};
</script>

<style lang="scss" scoped>
.navig {
  position: fixed;
  width: 184px;
  left: 250px;
}
.menuList {
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  display: flex;
}
.navigation-i {
  float: right;
  font-size: 12px;
  color: #909399;
}
.menu {
  position: absolute;
  left: 100px;
  background-color: white;
  display: none;
}
.navi-icon {
  width: 48px;
  height: 48px;
}
.search-navi-icon {
  width: 68px;
  height: 68px;
}
.yynavi {
  justify-content: space-between;
}
.jy-content-c {
  justify-content: center;
}
.nav-row-item:hover .start {
  display: inline-block;
}
.start {
  display: none;
}
.el-submenu__title {
  height: 40px;
}
</style>
